<template>
  <v-app>
      <BarraNavegacion 
       v-if="vista.nombre != '/home'  && vista.nombre != '/opciones_registro'
       && vista.nombre != '/login_general'
       && url_valida"  />
    <v-main>
    <v-snackbar
        v-model="snackbar.mostrar"
        :bottom="bottom"
        :color="snackbar.color"      
        :timeout="timeout"
    >
      {{ snackbar.texto }}
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-btn icon @click="snackbar.mostrar = false">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-snackbar>      
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Vista from "@/objetos/vista";
import Usuario from "@/objetos/usuario";
import BarraNavegacion from "@/components/BarraNavegacion/BarraNavegacion.vue";
import Login_cookie from '@/api/login_cookie.js';
import { validar_subdominio } from '@/api/validar_subdominio.js'
import host from '@/objetos/host.js';
import CrossSiteRedirect from '@/../../frontend_pedidos_web/src/funciones/app/cross_site_redirect.js'

const { HOST } = host;

//Verificamos versión del navegador
window.onload = function() {
  noatras();

  var useragent = navigator.userAgent;    
  var index = -1;

  //Agente mozilla incompatible.
  index = useragent.indexOf("Mozilla/4.0");

  //Inferior a android 6
  if(index == -1){       
    index = useragent.indexOf("Android");        
    if(index != -1){
      index = index + 8;      
      let version = useragent.slice(index);
      let android_os = version.split(";")[0]
      android_os = Number(android_os.split(".")[0]);
      if(android_os >= 6){        
        index = -1;
      }
    }    
  }
  //Inferior a windows seven

  if(index == -1){
    index = useragent.indexOf("Windows NT");    
    if(index != -1){      
      index = index + 11;      
      let version = useragent.slice(index);
      let windows_os = version.split(";")[0]
      windows_os = Number(windows_os.split(".")[0]);         
      if(windows_os >= 6){
        index = -1;
      }
    }   
  }

  if(index != -1){
    alert("Lo sentimos su dispositivo no cumple con las especificaciones mínimas para el uso de la aplicación");
  }
}

function noatras(){
  window.location.hash="no-back-button";
  window.location.hash="Again-No-back-button"
  window.onhashchange=function(){ window.location.hash=""; }
}

export default {
  name: "App",
  components: {
    BarraNavegacion
  },
  data: () => ({
    vista        : Vista,
    usuario      : Usuario,
    subdominio   : null,
    url_valida   : false,
    snackbar     : {
            mostrar :false,
            color   : null,
            texto   : null
    },
    timeout     : 10000,
    bottom      : true
  }),
  mounted(){
    this.$root.$on('snackbar', (snackbar) => {  
      this.snackbar.mostrar = true
      this.snackbar.color = snackbar.color
      this.snackbar.texto = snackbar.texto          
    })    
  },
  created(){
    CrossSiteRedirect.load(this);

    /*
      Verifica si ya existe una sesion iniciada y dependiento del tipo de usuario
      lo redirecciona a /pedidos_web, /configuraciones o /configuraciones_generales
    */
    this.login_cookie = Login_cookie.bind(this)
		this.login_cookie()
			.then((respuesta)=>{				
        this.seleccion_vista(respuesta)
			}) 

  },
  methods:{
    seleccion_vista(login){
      /*
        Si el primer subdominio de la aplicacion es "administracion" retorna el login 
        para usuarios "pncposweb" o "pdvtania".
      */
      let subdominio = HOST.split(".")[0];
      this.validar_url = validar_subdominio.bind(this);
      this.validar_url(subdominio,navigator.userAgent).then(respuesta => {     
        if (respuesta.subdominio == "coorporativa"){
          this.url_valida = true
          if(login){
            if( CrossSiteRedirect.redirectToView(this) ) {
               return;
            }
            this.$router.push("/distribuidor")     
            return
          }          
          this.usuario.direccion_soporte = respuesta && respuesta.direccion_soporte ? respuesta.direccion_soporte : "";
          this.$router.push("/home");
        } else if(respuesta.subdominio == "administracion"){
          document.querySelector('html').style.fontSize = '62.5%'     
          this.$router.push("/login_general");
        } else {
          this.$router.push("/404");
        }
      })      
    }    
  }
};
</script>
<style >
  @import "./assets/css/login.css";
</style>